<template>
	  <div class="content">
        <div class="qa_list">
           <h2>常见问题</h2>
            <div class="ant-card-body">
                <p class="text-bold">Q：为什么点击"参加考试"总是跳转到"登录"页面？</p>
                <p>A：考生您好，参加线上考试前请确保您已经登录了考试平台且登录账号已经通过了实名认证。</p><br>
                <p class="text-bold">Q：注册完考试平台后，实名认证流程需要多少时间？</p>
                <p>A：考生您好，按照注册页面的要求正确提交实名认证信息后一般需要2至3个工作日的认证时间，实名认证通过后我们会第一时间以短信的形式通知您。</p><br>
                <p class="text-bold">Q：我可以先参加"实操"考试再来参加线上理论考试吗？</p>
                <p>A：考生您好，不行哦，您只有通过了线上理论考试后才具备预约并参加"实操"考试的资格。</p><br>
                <p class="text-bold">Q：理论考试题目有多少道呀？</p><p>A：考生您好，理论考试题目一共有100道哦，其中单选题60道、多选题20道、判断题20道。</p><br>
                <p class="text-bold">Q：理论考试的考试时长是多少呀？</p>
                <p>A：考生您好，理论考试时长为90分钟，开始考试后开始倒计时，时间到了考试自动结束。</p><br>
                <p class="text-bold">Q：理论考试过程中关闭了考试页面会终止考试吗？</p>
                <p>A：考生您好，理论考试考试过程中当您关闭考试页面时考试就自动终止了，所以在关闭页面前请确保您已经完成了考试。</p><br>
                <p class="text-bold">Q：理论考试完后多久能收到考试成绩？</p>
                <p>A：考生您好，当您"提交考卷"后等待数秒即可看到您的考试成绩。</p><br>
                <p class="text-bold">Q：理论考试没通过怎么办？</p>
                <p>A：考生您好，您可以在考试后72小时再次参加考试。</p><br>
                <p class="text-bold">Q：我认识个朋友就是考官，我能直接在他那里预约好再来进行"实操"考试？</p>
                <p>A：考生您好，不可以，您只能通过平台的线上预约通道进行"实操"考试的预约，而且我们的考官都是随机分配的。</p><br>
                <p class="text-bold">Q：考完了"实操"考试后多久能收到考试成绩？</p>
                <p>A：考生您好，考完实操考试后，您可以在次月10号登录"考试认证平台"查询您的考试结果，我们也会短信通知您的。</p><br>
                <p class="text-bold">Q：考试通过后会发放证书？</p>
                <p>A：考生您好，当您通过了"实操"考试后，您需要在平台填写您的收件信息，我们将快递给您证书哦。</p><br>
                <p class="text-bold">Q：理论考试笔试过程中可以短暂离开？</p>
                <p>A：考生您好，如果您在考试过程中遇到紧急事情可以短暂离开哦，但是切记不要关闭考试页面哦，这样还能回来继续参加考试。</p><br>
                <p class="text-bold">Q：我能用比心账号登录认证考试平台吗？</p><p>A：考生您好，不能哦，您必须在认证考试平台重新注册账号。</p><br>
            </div>
        </div>
        </div>
</template>
<style scoped>
.qa_list{background:#fff; margin-top:20px;padding-bottom:64px; margin-bottom:24px;}
.qa_list h2{ height:68px; line-height:68px; font-size:24px;  color:#666; font-weight:normal; text-align:center;}
.qa_list .ant-card-body{ padding:24px;}
.qa_list p{font-size: 14px;color:#666;margin-bottom:14px; }
.qa_list p.text-bold{color:#333;}
</style>
<script>   
	export default {
		name: 'qa',
		methods: {
		},
		data() {
			return {
				
			}
		},
		computed:{
			
		},
		mounted: function () {
			
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/qa.vue